import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  input,
  signal
} from '@angular/core';
import { Editor, Toolbar, NgxEditorModule } from 'ngx-editor';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FormFieldLabelComponent } from '../../legacy/form/form-field/form-field-label/form-field-label.component';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true })
    }
  ],
  imports: [
    FormFieldLabelComponent,
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe
  ]
})
export class TextEditorComponent implements OnInit, OnDestroy {
  readonly controlKey = input.required<string>();
  readonly required = signal(false);
  controlContainer = inject(ControlContainer);

  public editor: Editor;
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'link'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear']
  ];

  public ngOnInit(): void {
    this.editor = new Editor();

    this.required.set(
      this.controlContainer.control
        .get(this.controlKey())
        .hasValidator(Validators.required)
    );
  }

  public ngOnDestroy(): void {
    this.editor.destroy();
  }
}
